import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {RacesService} from '../shared/services/databaseServices/races/races.service';
import {EditService} from '../shared/services/editService/edit.service';
import {FormBuilder, Validators} from '@angular/forms';
import {FioConfig} from '../shared/classes/FioConfig';
import {FioService} from '../shared/services/databaseServices/fioService/fio.service';
import {RacePageParrent} from '../shared/classes/RacePageParrent';
import {faFilter, faRedo} from '@fortawesome/free-solid-svg-icons';
import {FioLine} from '../shared/classes/FioLine';
import {formatDate} from '@angular/common';

@Component({
  selector: 'app-race-fio',
  templateUrl: './race-fio.component.html',
  styleUrls: ['./race-fio.component.css']
})
export class RaceFioComponent extends RacePageParrent implements OnInit {

  private static NEW_ID = 'new';

  faFilter = faFilter;
  faRedo = faRedo;
  id = undefined;
  isNew = false;
  fioTable: FioLine[] = undefined;
  fioFilteredTable: FioLine[] = undefined;
  fioConfig: FioConfig[] = undefined;
  createTooltip = 'fioSetting.tooltip.saveToolTip';
  deleteTooltip = 'fioSetting.tooltip.deleteToolTip';
  addTooltip = 'fioSetting.tooltip.addToolTip';
  plusButton = false;
  editButton = true;
  raceId;
  minFromDate = undefined;
  maxToDate = new Date();
  minDateHelp = '';

  private fioDetail: FioConfig = new FioConfig();

  fioForm = this.formBuilder.group({
    profile: ['', []],
    fromDate: ['', [Validators.required]]
  });

  fioRuntime = this.formBuilder.group({
    oneDay: ['', []],
    fromDate: ['', []],
    toDay: ['', []]
  });

  displayedColumns: string[] = ['date', 'value', 'currency', 'from', 'fromAccount', 'bankCode', 'varSym', 'message'];

  header = [
    {
      defName: 'date',
      translation: 'raceDetailPage.fio.table.date',
      elem: 'date'
    },
    {
      defName: 'value',
      translation: 'raceDetailPage.fio.table.value',
      elem: 'value'
    },
    {
      defName: 'currency',
      translation: 'raceDetailPage.fio.table.currency',
      elem: 'currency'
    },
    {
      defName: 'from',
      translation: 'raceDetailPage.fio.table.from',
      elem: 'from'
    },
    {
      defName: 'fromAccount',
      translation: 'raceDetailPage.fio.table.fromAccount',
      elem: 'fromAccount'
    },
    {
      defName: 'bankCode',
      translation: 'raceDetailPage.fio.table.bankCode',
      elem: 'bankCode'
    },
    {
      defName: 'varSym',
      translation: 'raceDetailPage.fio.table.varSym',
      elem: 'varSym'
    },
    {
      defName: 'message',
      translation: 'raceDetailPage.fio.table.message',
      elem: 'message'
    },
  ];

  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              private racesService: RacesService,
              private fioService: FioService,
              private editService: EditService,
              private formBuilder: FormBuilder) {
    super();
  }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    if (this.id === RaceFioComponent.NEW_ID) {
      this.id = this.racesService.lastSave;
    }
    this.isNew = this.id === RaceFioComponent.NEW_ID;
    this.loadFioProfile();
    if( this.isNew ) {

    } else {
      this.racesService.getOne(this.id).then( data => {
        this.raceId = data.id;
        this.createRace(data);
        this.fillForm();
        this.loadFioConfir();
      });
    }
  }

  private loadFioConfir(){
    this.fioService.getOne(this.race.fioConfig.profile).then(data => {
      this.fioDetail.token = data.data().token;
      this.fioDetail.profile = data.data().profile;
      this.fioDetail.id = data.id;

      const fromDate = this.formatString(this.minFromDate);
      const now = this.formatString(new Date());
      this.loadPayments(this.fioDetail.token, fromDate, now);
    });
  }

  private formatString(date: Date): string {
    return formatDate(date, 'yyyy-MM-dd', 'en-US');
  }

  private loadPayments(token, fromDate, toDate) {
    this.fioService.getFioTransaction(token, fromDate, toDate).then( data => {
      this.parseFioData(data);
    });
  }

  private checkNull(object){
    return object === null ? {value: ''} : object;
  }

  private parseFioData(data){
    this.fioTable = [];
    this.fioFilteredTable = [];
    data.accountStatement.transactionList.transaction.forEach( t => {
      const fioLine = new FioLine();
      fioLine.id = this.checkNull(t.column22).value;
      fioLine.date = this.checkNull(t.column0).value;
      fioLine.value = this.checkNull(t.column1).value;
      fioLine.currency = this.checkNull(t.column14).value;
      fioLine.from = this.checkNull(t.column10).value;
      fioLine.fromAccount = this.checkNull(t.column2).value;
      fioLine.bankCode = this.checkNull(t.column3).value;
      fioLine.varSym = this.checkNull(t.column5).value;
      fioLine.message = this.checkNull(t.column16).value;

      this.fioTable.push(fioLine);
      this.fioFilteredTable.push(fioLine);
    });
  }

  loadFiltered(data) {
    this.fioFilteredTable = [];
    this.fioFilteredTable = data;
  }

  fillForm() {
    this.fioForm.patchValue(
      {profile: this.race.fioConfig.profile,
        fromDate: this.race.fioConfig.dateFrom.toDate()}
    );
    this.minFromDate = this.race.fioConfig.dateFrom.toDate();
    this.fioRuntime.patchValue(
      {fromDate: this.minFromDate}
    );
    this.fioRuntime.get('fromDate').setValidators(Validators.min(this.minFromDate));
    this.minDateHelp = "Nejdřívější datem co jde zadat je: " + this.minFromDate;
  }

  saveOnChange() {
    this.fioForm.valueChanges.subscribe(val => {
    });
  }

  save(item) {
    const config: FioConfig = new FioConfig();
    config.profile = this.fioForm.get('profile').value;
    config.dateFrom = new Date(this.fioForm.get('fromDate').value);
    this.race.fioConfig = config;
    this.racesService.update(this.race.id, this.race).then( () => {
      this.ngOnInit();
    }).catch(err => {
      console.dir(err);
    });
  }

  remove(item) {

  }

  add(item) {

  }

  filter() {
    const fromDate = this.formatString(this.fioRuntime.get('fromDate').value);
    const toDate = this.formatString(this.fioRuntime.get('toDay').value);
    const token = this.fioDetail.token;
    this.loadPayments(token, fromDate, toDate);
  }

  reload() {
    this.fioRuntime.patchValue({toDay: new Date(), fromDate: this.minFromDate});
    this.filter();
  }

  private loadFioProfile(){
    this.fioService.getAll().then(data => {
      const fios = [];

      data.forEach(item => {
        const fioConf: FioConfig = new FioConfig();
        fioConf.id = item.id;
        fioConf.profile = item.data().profile;
        fioConf.token = item.data().token;
        fios.push(fioConf);
      });
      this.fioConfig = fios;
    })
  }

}
